import React, { useEffect, useRef, useState } from "react";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import CustomButton from "../../CustomButton/CustomButton";
import SwitchToggle from "../../Switch/SwitchToggle";
import { MenuItemsContainer } from "./CustomColumnsMenuContainer";
import { axiosFunction } from "../../../commonFunctions/axiosFunction"; 
import { v2ReactURL } from "../../../../utils/constant";
import { Checkbox, FormControlLabel, FormGroup, Input } from "@mui/material";
import { useSelector } from "react-redux";
import { Column } from "../../CustomDataTable/CustomDataTable";
import { CheckedValue, DynamicCol } from "../../../../pages/Contact/MainDataTable";



interface CustomColumnMenuComponentProps {
 data : Column[]; 
 setColumns : React.Dispatch<React.SetStateAction<Column[]>>;
 setOpenMenu : React.Dispatch<React.SetStateAction<boolean>>;
 openMenu : boolean;
 handleSearchColumn: (e: React.ChangeEvent<HTMLInputElement| HTMLTextAreaElement>) => void;
 searchColumn: string;
 defaultColumns: Column[];
 dynamicCol:DynamicCol[];
 setDynamicCol: React.Dispatch<React.SetStateAction<DynamicCol[]>>;
 checked: boolean;
 setChecked: React.Dispatch<React.SetStateAction<boolean>>;
  tableData: Column[];
  setSearchColumn: React.Dispatch<React.SetStateAction<string>>;
  checkedValue: CheckedValue;
  handleClearFilter: () => void;
  open: boolean[];

}

const CustomColumnMenuComponent = ({
  data,
  setColumns,
  setOpenMenu,
  handleSearchColumn,
  searchColumn,
  defaultColumns,
  dynamicCol,
  setDynamicCol,
  checked,
  setChecked,
  tableData,
  setSearchColumn,
  checkedValue,
  handleClearFilter,
  open
} : CustomColumnMenuComponentProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const contactType = useSelector((state:any) => state.contactType);

  const [show, setShow] = useState(false);
  
  useEffect(() => {
   
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      // Click outside the menu, close the menu
      setOpenMenu(false);
      setShow(!show);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  const handleColumnsMenu = () => {
    // setOpenMenu(!openMenu);
    setShow(!show);
  };
  const isopenalltrue = open.every((state) => state === true);
  const saveDynamicColumn = async (columnsPayload:DynamicCol[], setDefault:boolean) => {
   
    const payloadData = {
      dynamicColumnId: 1,
      userFrontId: 5954,
      companyId: 5954,
      tableName: contactType,
      dynamicColumnsJson: { dynamicColumns: columnsPayload },
      setDefault: setDefault,
    };
     await axiosFunction(
      `${v2ReactURL}/contact/dynamic/columns/save`,
      "POST",
      payloadData
    );
  };

  const handleSwitchToggle = (row: Column) => {
    if (checkedValue.hasOwnProperty(row.field)) {
      handleClearFilter();
    }
  
    setColumns((prevState) =>
      prevState.map((column) =>
        column.field === row.field
          ? { ...column, defaultChecked: !column.defaultChecked }
          : column
      )
    );
  
    setDynamicCol((prevDynamicCol) =>
      prevDynamicCol.map((column) =>
        column.key === row.field
          ? { ...column, value: !column.value }
          : column
      )
    );
  
    setSearchColumn("");
    setChecked(false);
  };
  

  const handleShowAllBtn = () => {
    const unCheckedData = data.some((col) => !col.defaultChecked);

    if (unCheckedData) {
      const updatedData = data.map((col) => ({
        ...col,
        defaultChecked: true,
      }));

      setColumns(updatedData);

      const updatedColumns = dynamicCol.map((col) => ({ ...col, value: true }));
      setDynamicCol(updatedColumns);

      if (checked) {
    
        saveDynamicColumn(updatedColumns, checked);
      }
    }
  };

  const handleRestoreBtn = () => {
    setColumns(defaultColumns);

    const restoredDynamicCol = dynamicCol.map((dynamicColItem) => {
      const defaultColumn = defaultColumns.find(
        (defaultColItem) => defaultColItem.field === dynamicColItem.key
      );
      if (defaultColumn) {
        return {
          ...dynamicColItem,
          value: defaultColumn.defaultChecked ?? false,
        };
      } else {
        return dynamicColItem;
      }
    });

    setDynamicCol(restoredDynamicCol);

    if (checked) {
      
      saveDynamicColumn(restoredDynamicCol, false);
    }
    setChecked(false);
  };

  const handleSetDefaultValue = async (e:React.ChangeEvent<HTMLInputElement>) => {
    const defaultColumnsPayload = data.map((col) => {
      return {
        columnTitle: col.headerName,
        key: col.field,
        value: col.defaultChecked ?? false,
      };
    });

    const columns =
      dynamicCol?.length <= 0 ? defaultColumnsPayload : dynamicCol;

    if (e.target.checked) {
      setChecked(true);
      // console.log("columns")
      saveDynamicColumn(columns, true);
    } else {
      setChecked(false);
    }
  };

  const defaultChecker = (column:Column) => {
    const dynamicColField = dynamicCol.find((col) => col.key === column.field);

    if (dynamicColField) {
      return dynamicColField.value;
    } else {
      return column.defaultChecked ?? false;
    }
  };

 

  return (
    <>
      <CustomButton
        open={true}
        onClick={handleColumnsMenu}
        iconComponent={<ViewWeekIcon sx={{ fontSize: "16px" }} />}
        btnName={"Columns"}
      />

      {show ? (
        <MenuItemsContainer ref={menuRef} isopenalltrue={isopenalltrue} >
          <span style={{ color: "#00a4e5", fontWeight: 500 }}>Find Column</span>
          <div className="search-box">
            <Input
              placeholder="Column Title"
              inputProps={{ "aria-label": "description" }}
              sx={{
                marginTop: "5px",
                width: "100%",
                marginBottom: "10px",
                fontFamily: '"Plus Jakarta Sans", sans-serif',
              }}
              value={searchColumn}
              onChange={(e) => handleSearchColumn(e)}
            />
          </div>
          <div className="menu-items">
            {tableData.map((col, index) => {
              return (
                <div key={index} className="itemList">
                  <div className="itemName">{col.headerName}</div>
                  <div>
                    <SwitchToggle
                      checked={defaultChecker(col)}
                      onChange={() => handleSwitchToggle(col)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleSetDefaultValue}
                  checked={checked}
                  disabled={checked}
                />
              }
              label="Set As Default"
            />
          </FormGroup>
          <div className="footer-buttons">
            <div className="buttons" onClick={handleRestoreBtn}>
              Restore
            </div>
            <div className="buttons" onClick={() => handleShowAllBtn()}>
              Show all
            </div>
          </div>
        </MenuItemsContainer>
      ) : (
        ""
      )}
    </>
  );
};

export default CustomColumnMenuComponent;
